export default {
	scrollUp: "Nach oben scrollen",
} as const;
